import App from '../App'
import Block from './Block'
import LightBox from '../util/LightBox'

export default class SinglePost extends Block {

  onEnterCompleted() {
    App.cursor.resetScale()
    App.cursor.resetBorders()
  }

  getElems() {
    super.getElems()

    this.imagesElt = this.el.querySelectorAll('img')
    this.imagesSrc = []

    this.createLightBox()
  }

  createLightBox() {
    for (let i = 0; i < this.imagesElt.length; i++) this.imagesSrc.push(this.imagesElt[i].dataset.srcOpen)

    this.lightBox = new LightBox({
      gallery: this.imagesSrc
    })
  }

  events() {
    for (let i = 0; i < this.imagesElt.length; i++) {
      this.imagesElt[i].addEventListener('click', this.onImageClick.bind(this, i))
    }
  }

  onImageClick(i) {
    this.lightBox.open()
    this.lightBox.showAtIndex(i)
  }

  resize() {
    super.resize()

    this.lightBox.resize()
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/SinglePost.js